module.exports = __webpack_public_path__ + "static/media/logo.d26832e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/flexhouse/logo.svg
// module id = 357
// module chunks = 0